enum ChannelView {
  Classic,
  Lineup,
  Grid,
}

export default ChannelView;
